import React from 'react';
import { Platform } from 'react-native';
import Animated, { Extrapolate, interpolate, interpolateColor, useAnimatedStyle, } from 'react-native-reanimated';
import { rem } from 'design-system';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import useColors from 'hooks/useColors';
import useColorScheme from 'hooks/useColorScheme';
import useHeaderHeight from 'hooks/useHeaderHeight';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import LinearGradient from 'utils/packages/linearGradient';
import DistributionTotalCardContent from './DistributionTotalCardContent';
const DistributionTotalCard = ({ scrollY, total, handleClear, headerInfoHeight }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const headerHeight = useHeaderHeight();
    const colorScheme = useColorScheme();
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const headerBackground = useAnimatedStyle(() => ({
        transform: [
            {
                translateY: interpolate(scrollY.value, [0, headerInfoHeight, headerInfoHeight + 1], [headerInfoHeight, 0, 0]),
            },
        ],
    }));
    const animatedMargins = useAnimatedStyle(() => ({
        backgroundColor: interpolateColor(scrollY.value, [headerInfoHeight - 20, headerInfoHeight], [
            colors.background.dark,
            colors.cards.onDark,
        ]),
        shadowOpacity: colorScheme === 'dark' ? 0 : interpolate(scrollY.value, [headerInfoHeight - 20, headerInfoHeight], [0, 1]),
    }), [scrollY.value, colors.background.dark, colors.cards.onDark, colorScheme, headerInfoHeight]);
    const androidShadowOpacity = useAnimatedStyle(() => ({
        opacity: interpolate(scrollY.value, [headerInfoHeight - 20, headerInfoHeight], [0, 1], Extrapolate.CLAMP),
    }));
    return (<Animated.View style={[styles.background, headerBackground, { marginTop: headerHeight }]}>
      <Animated.View style={[styles.container, animatedMargins, paddingHorizontalStyle]}>
        <DistributionTotalCardContent total={total} handleClear={handleClear}/>
      </Animated.View>
      {Platform.OS === 'android' && (<Animated.View style={androidShadowOpacity}>
          <LinearGradient pointerEvents="none" style={[styles.androidShadow]} colors={[
                colors.shadows.androidShadowGradientStart,
                colors.shadows.androidShadowGradientEnd,
            ]}/>
        </Animated.View>)}
    </Animated.View>);
};
const styleSet = createStyleSheets((colors) => ({
    background: {
        position: 'absolute',
        left: 0,
        right: 0,
        zIndex: 1,
    },
    androidShadow: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 10,
    },
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    flex: {
        flex: 1,
    },
    container: {
        ...colors.shadows.extendedHeader,
    },
}));
export const distributionTotalCardHeight = rem(56);
export default DistributionTotalCard;
